import React from 'react';
import { trafficColorsClass, roundNumber } from 'utils/general';

class BarChartVertical extends React.Component {
  componentDidMount() {
    this.setSvg(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.setSvg(nextProps);
  }

  setSvg(props) {
    const { data, id, margin: marginVals = {}, graphHeight = 400 } = props;
    const xAxisLabel = data.length ? data[0].xAxisLabel : '';
    const spaceBetween = window.innerWidth < 712 && data.length > 5 ? 34 : 45;
    const varWidth = (spaceBetween * data.length) + 60;
    const margin = { top: 10, right: 20, bottom: 40, left: 100, ...marginVals };
    const width = varWidth - margin.left - margin.right;
    const height = graphHeight - margin.top - margin.bottom;
    const barsWidth = 18;
    let svg = d3.select('svg');

    // Remove svg to avoid append
    const svgEl = d3.select(`#${id} svg`)[0];
    svgEl[0] && svgEl[0].remove();

    const x = d3.scale.ordinal().rangeRoundBands([0, width], 0.05)
      .domain(data.map((d) => d.name));
    const y = d3.scale.linear().range([height, 0])
      .domain([0, 100]);

    const xAxis = d3.svg.axis()
      .scale(x)
      .orient('bottom')
      .tickFormat(name => name.length > 25 ? `${name.slice(0, 30)}...` : name);

    const yAxis = d3.svg.axis()
      .scale(y)
      .orient('left')
      .innerTickSize(-width)
      .tickPadding(10)
      .ticks(5);

    svg = d3.select(`#${id}`).append('svg')
      .attr('width', width + margin.left + margin.right)
      .attr('height', height + margin.top + margin.bottom)
    .append('g')
      .attr('transform', `translate(${margin.left} , ${margin.top})`);

    svg.append('g')
      .attr('class', 'x axis')
      .attr('transform', `translate(0, ${height})`)
      .call(xAxis)
      .selectAll('text')
        .style('text-anchor', 'middle')
        .attr('dy', '16px')
        .attr('class', (d, i) => {
          let className = 'x-label';
          className += data[i].score === null ? '-no-data' : '';
          return className;
        });
        // .attr('transform', (d, i) => {
        //   const max = -1;
        //   return i === 0 ?
        //     'translate(-14, 0) rotate(-45)' : `translate(${max - ((i - 1) * 4 + 5)}, 0) rotate(-45)`;
        // });

    svg.append('g')
      .attr('class', 'y axis')
      .call(yAxis)
      .select('.domain')
      .remove();

    svg.append('text')
    .attr('text-anchor', 'end')
    .attr('x', width)
    .attr('y', height + 60)
    .attr('fill', 'white')
    .text(xAxisLabel || '');
    this.appendBars(svg, height, x, y, barsWidth, props);
    this.appendLabel(svg, height, x, y, barsWidth, props);
  }

  appendBars(svg, height, x, y, barsWidth, props) {
    const { data } = props;
    const tooltip = d3.selectAll('.c-tooltip-graph');

    svg.append('g')
      .attr('class', 'bars')
      .selectAll('bar')
        .data(data)
        .enter()
        .append('rect')
          .attr('x', (d) => x(d.name))
          .attr('dx', '40')
          .attr('dy', '40px')
          .attr('width', `${barsWidth}px`)
          .attr('class', (d) => trafficColorsClass(d.score))
          .attr('y', (d) => {
            if (d.score === '0.0') return 0;
            return y(d.score || 100);
          })
          .attr('transform', (d, i) => {
            const max = 18;
            return (i === 0) ? 'translate(10, 0)' : `translate(${max - ((i - 1) * 4)}, 0)`;
          })
          .attr('height', (d) => {
            if (d.score === '0.0') return 100;
            return height - y(d.score || 100);
          })
          .on('mousemove', (d) => {
            tooltip
              .style('left', `${d3.event.pageX - 50}px`)
              .style('top', `${d3.event.pageY - 70}px`)
              .style('display', 'flex')
              .html(`<span class="title">${d.name}</span><span class="value">${d.score === null ? 'Not covered' : roundNumber(d.score)}</span>`);
          })
          .on('mouseout', () => tooltip.style('display', 'none'));
  }

  appendLabel(svg, height, x, y, barsWidth, props) {
    const { data } = props;

    svg.append('g')
      .attr('class', 'score-value')
      .selectAll('score-value')
        .data(data)
        .enter()
        .append('text')
          .attr('fill', 'white')
          .text(d => roundNumber(d.score))
          .attr('x', (d) => x(d.name))
          .attr('y', (d) => y(d.score) - 8)
          .attr('transform', (d, i) => {
            const max = 16;
            return (i === 0) ? 'translate(4, 0)' : `translate(${max - ((i - 1) * 4)}, 0)`;
          });
          // .attr('height', (d) => height - y(d.best))
          // .on('mousemove', (d) => {
          //   tooltip
          //     .style('left', `${d3.event.pageX - 50}px`)
          //     .style('top', `${d3.event.pageY - 70}px`)
          //     .style('display', 'flex')
          //     .html(`<span class="title">Best in sample</span><span class="value">${roundNumber(d.best)}</span>`);
          // })
          // .on('mouseout', () => tooltip.style('display', 'none'));
  }

  render() {
    return (
      <div id={`${this.props.id}`} className="c-bars-dots small-12"></div>
    );
  }
}

BarChartVertical.propTypes = {
  data: React.PropTypes.array,
  id: React.PropTypes.string
};

export default BarChartVertical;



// WEBPACK FOOTER //
// ./app/components/common/charts/BarChartVertical.jsx